import { network } from '@root/utils/network'
import { MutationFunction } from './root'

export interface CompleteOnboardStepInput {
  slug: string
  stepId: number
  sources?: string[]
  detail_text?: string
  has_accrual_based_entries_for_invoicing?: boolean
}

export const completeOnboardStep: MutationFunction<CompleteOnboardStepInput, void> = async ({
  slug,
  stepId,
  sources,
  detail_text,
  has_accrual_based_entries_for_invoicing
}) => {
  const url = `/v1/business/${slug}/onboard_step/${stepId}/complete/`
  const data: Record<string, unknown> = {}
  if (sources !== undefined) {
    data.sources = sources
    data.detail_text = detail_text
  }
  if (has_accrual_based_entries_for_invoicing !== undefined) {
    data.has_accrual_based_entries_for_invoicing = has_accrual_based_entries_for_invoicing
  }
  await network.httpClient.request({
    url,
    method: 'POST',
    data: Object.keys(data).length > 0 ? data : undefined
  })
}

export const dismissOnboardStep: MutationFunction<{ slug: string; stepId: number }, void> = async ({
  slug,
  stepId
}) => {
  const url = `/v1/business/${slug}/onboard_step/${stepId}/dismiss/`
  await network.httpClient.request({
    url,
    method: 'POST'
  })
}

export const undismissOnboardStep: MutationFunction<
  { slug: string; stepId: number },
  void
> = async ({ slug, stepId }) => {
  const url = `/v1/business/${slug}/onboard_step/${stepId}/undismiss/`
  await network.httpClient.request({
    url,
    method: 'POST'
  })
}
